// src/services/geral/LoginService.js
import axios from 'axios';

export const autenticarNoErp = async (login, senha) => {
    const baseURL = window.APP_CONFIG?.Url_Api || 'http://default-url.com';
    return axios.post(`${baseURL}/loginERP`, { login, senha });
};
